<template>
<div>
  <ul v-if="pagination.hasPages" class="pagination justify-content-center d-none d-sm-flex">

    <li v-if="pagination.onFirstPage" class="page-item disabled">
      <span class="page-link">&laquo;</span>
    </li>
    <li v-else class="page-item">
      <a class="page-link" @click.prevent="paginate({ page: pagination.currentPage - 1 })" :href="pagination.previousPageUrl" rel="prev">&laquo;</a>
    </li>

    <template v-for="(element, index) in pagination.elements">

      <li v-if="typeof element === 'string'" class="page-item disabled" :key="`el-${index}`"><span class="page-link">{{ element }}</span></li>

      <template v-if="typeof element === 'object'">
        <template v-for="(url, index) in element">
            <li v-if="pagination.currentPage == index" :key="`el-sub-${index}`" class="page-item active">
              <span class="page-link">{{ index }}</span>
            </li>
            <li v-else :key="`el-sub-${index}`" class="page-item">
              <span v-if="index == page && loading" class="page-link">
                <font-awesome-icon icon="spinner" spin size="xs"></font-awesome-icon>
              </span>
              <a v-else class="page-link" :href="url" @click.prevent="paginate({ page: index })">{{ index }}</a>
            </li>
        </template>
      </template>

    </template>

    <li v-if="pagination.hasMorePages" class="page-item">
      <a class="page-link"  @click.prevent="paginate({ page: pagination.currentPage + 1 })" :href="pagination.nextPageUrl" rel="next">&raquo;</a>
    </li>
    <li v-else class="page-item disabled">
      <span class="page-link">&raquo;</span>
    </li>
  </ul>
  <ul v-if="pagination.hasPages" class="pagination justify-content-center d-flex d-sm-none">

    <li v-if="pagination.onFirstPage" class="page-item disabled">
      <span class="page-link">&laquo;</span>
    </li>
    <li v-else class="page-item">
      <a class="page-link" @click.prevent="paginate({ page: pagination.currentPage - 1 })" :href="pagination.previousPageUrl" rel="prev">&laquo;</a>
    </li>

    <template v-for="(element, index) in pagination.elements">

      <li v-if="typeof element === 'string'" class="page-item disabled" :key="`el-${index}`"><span class="page-link">{{ element }}</span></li>

      <template v-if="typeof element === 'object'">
        <template v-for="(url, index) in element">
            <li v-if="pagination.currentPage == index" :key="`el-sub-${index}`" class="page-item active">
              <span class="page-link">{{ index }}</span>
            </li>
            <li v-else :key="`el-sub-${index}`" class="page-item">
              <span v-if="index == page && loading" class="page-link">
                <font-awesome-icon icon="spinner" spin size="xs"></font-awesome-icon>
              </span>
              <a v-else class="page-link" :href="url" @click.prevent="paginate({ page: index })">{{ index }}</a>
            </li>
        </template>
      </template>

    </template>

    <li v-if="pagination.hasMorePages" class="page-item">
      <a class="page-link"  @click.prevent="paginate({ page: pagination.currentPage + 1 })" :href="pagination.nextPageUrl" rel="next">&raquo;</a>
    </li>
    <li v-else class="page-item disabled">
      <span class="page-link">&raquo;</span>
    </li>
  </ul>
</div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('filters')

export default {
  computed: mapState(['pagination', 'page', 'loading']),
  methods: mapActions(['paginate'])
}
</script>
